import type { AppSettings } from '@/types/AppSettings';

const settings = {
  currency: {
    label: process.env.APP_CURRENCY_LABEL || 'AUD',
    locale: process.env.APP_CURRENCY_LOCALE || 'en-AU',
    symbol: process.env.APP_CURRENCY_SYMBOL || '$',
  },
} as AppSettings;

export default settings;
